import reScreenshots from '@images/re-screenshots.png'
import reggieWaving from '@images/reggie-waving.png'
import Component from '@glimmer/component'
import { t } from 'ember-intl'
import perform from 'ember-concurrency/helpers/perform'
import { service } from '@ember/service'
import { on } from '@ember/modifier'
import { LinkTo } from '@ember/routing'
import { PageHeader } from 'teacher-ui-client/components/page-header'
import { UiButton } from 'teacher-ui-client/components/ui-button'
import { UiButtonLinkTo } from 'teacher-ui-client/components/ui-button/link-to'
import { ButtonAppearance } from 'teacher-ui-client/components/ui-button/themes'
import { SubscriptionType } from 'teacher-ui-client/subscription-type/subscription-types'
import type { IntlService } from 'ember-intl'
import type Teacher from 'teacher-ui-client/models/teacher'
import type { Task } from 'ember-concurrency'
import type SessionService from 'teacher-ui-client/services/session'

interface Signature {
  Element: HTMLDivElement
  Args: {
    createTeacherSubTask: Task<void, [SubscriptionType, Teacher]>
  }
}

export class PageAccessMissingReading extends Component<Signature> {
  @service intl!: IntlService

  @service session!: SessionService

  get isOneRoster() {
    return Boolean(this.session.currentSchool.oneRosterEnabledAt)
  }

  get sideImg() {
    return {
      src: reggieWaving,
      alt: this.intl.t('pages.accessMissing.sideImgAlt'),
    }
  }

  get screenshotsImg() {
    return {
      src: reScreenshots,
      alt: this.intl.t('pages.accessMissing.screenshotsImgAlt'),
    }
  }

  <template>
    <div ...attributes>
      <PageHeader>
        <:title>
          <h1>{{t "pages.accessMissing.title.reading"}}</h1>
        </:title>
      </PageHeader>

      <div class="mx-auto max-w-4xl overflow-hidden">
        <img class="float-right" src={{this.sideImg.src}} alt={{this.sideImg.alt}} />

        <p class="mb-3">{{t "pages.accessMissing.description.reading.para1"}}</p>
        <p class="mb-3">{{t "pages.accessMissing.description.reading.para2"}}</p>

        {{#if this.isOneRoster}}
          <p class="mb-3 text-center">
            <UiButtonLinkTo
              data-test-contact-us-button
              class="mx-auto"
              @appearance={{ButtonAppearance.regular}}
              @route="subscription-type.contact-us"
            >
              {{t "pages.accessMissing.button.reading.contactUs"}}
            </UiButtonLinkTo>
          </p>
          <p class="mb-3 text-center font-semibold">
            {{t "pages.accessMissing.button.reading.contactUsExplainer"}}
          </p>
        {{else}}
          <p class="mb-3 text-center">
            <UiButton
              data-test-start-trial
              class="mx-auto"
              disabled={{@createTeacherSubTask.isRunning}}
              @appearance={{ButtonAppearance.regular}}
              {{on "click" (perform @createTeacherSubTask SubscriptionType.Reading this.session.currentTeacher)}}
            >
              {{t "pages.accessMissing.button.reading.text"}}
            </UiButton>
          </p>
          <p class="mb-3 text-center font-semibold">
            {{t "pages.accessMissing.button.reading.explainer"}}
          </p>

          <p class="my-8 text-center">
            {{t "pages.accessMissing.contactUs.pre"}}
            <LinkTo @route="subscription-type.contact-us" data-test-contact-us-link>
              {{t "pages.accessMissing.contactUs.link"}}
            </LinkTo>
          </p>
        {{/if}}

        <img class="mx-auto" src={{this.screenshotsImg.src}} alt={{this.screenshotsImg.alt}} />
      </div>
    </div>
  </template>
}
